// extracted by mini-css-extract-plugin
module.exports = {"heading":"discoverAdsFeature_heading__1b1Sx","clearFilter":"discoverAdsFeature_clearFilter__vvMiV","createMyAccount":"discoverAdsFeature_createMyAccount__8SgJ_"};